import { accountHasSkillSlug } from '@/lib/service-plans/skill-gate';

/**
 * Is the Inbox on for this account?
 *
 * Since 24 Sep 2026 the answer is "the `inbox` skill is installed". It was
 * early access until 2026-10-27 (docs/inbox-early-access-plan.md) and is now on
 * general sale: the owner installs it from the Skills page and the wizard hands
 * over to Connect Gmail.
 *
 * It replaced an env-var allowlist (`NEXT_PUBLIC_INBOX_BETA_ACCOUNT_IDS`), which
 * could only be changed by a redeploy and had no way for an owner to ask.
 *
 * 🚨 Still a VISIBILITY gate, not a security boundary. Every permission check
 * (`view_inbox`, `manage_mailboxes`, `send_email_replies`) and every mailbox
 * scope still applies underneath it and is what actually protects anybody's
 * mail. This decides who is offered the feature, nothing more.
 *
 * Two forms, one answer: `inboxInstalled` for a route that has only an
 * account id, `inboxEnabledFor` for a screen that already holds the
 * installed-skills list (sidebarData.enabledSkillSlugs). The list of call
 * sites is pinned by `an-inbox-behind-the-flag.test.ts`.
 */
export async function inboxInstalled(accountId: string | null | undefined): Promise<boolean> {
  if (!accountId) return false;
  return accountHasSkillSlug(accountId, 'inbox');
}

export function inboxEnabledFor(enabledSkillSlugs: readonly string[] | null | undefined): boolean {
  return !!enabledSkillSlugs?.includes('inbox');
}
